export const FETCH_PRODUCTS = 'products/FETCH';
export const FETCH_PRODUCTS_SUCCESS = `${FETCH_PRODUCTS}_SUCCESS`;
export const FETCH_PRODUCTS_FAIL = `${FETCH_PRODUCTS}_FAIL`;

export const FETCH_PRODUCTS_GENERIC = 'productsGeneric/FETCH';
export const FETCH_PRODUCTS_GENERIC_SUCCESS = `${FETCH_PRODUCTS_GENERIC}_SUCCESS`;
export const FETCH_PRODUCTS_GENERIC_FAIL = `${FETCH_PRODUCTS_GENERIC}_FAIL`;

export const FETCH_PRODUCTS_RELATED = 'productsRelated/FETCH';
export const FETCH_PRODUCTS_RELATED_SUCCESS = `${FETCH_PRODUCTS_RELATED}_SUCCESS`;
export const FETCH_PRODUCTS_RELATED_FAIL = `${FETCH_PRODUCTS_RELATED}_FAIL`;

export const RESET_RELATED_PRODUCTS = "productsRelated/RESET_RELATED_PRODUCTS";

const initialState = {
  isLoading: false,
  isLoadingRelated: false,
  isLoaded: false,
  products: [],
  productsGeneric: [],
  productsRelated: [],
  error: null,
  isErrorRelated: false,
  isSuccessRelated: false,
};

export const ProductsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return { ...state, isLoading: true, isLoaded: false };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: [...state.products, action.payload.data],
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_PRODUCTS_FAIL:
      return {
        ...state, isLoaded: false, isLoading: false, error: action.error,
      };
    default: return state;
  }
};

export const ProductsGenericReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_PRODUCTS_GENERIC:
      return { ...state, isLoading: true, isLoaded: false };
    case FETCH_PRODUCTS_GENERIC_SUCCESS:
      return {
        ...state,
        productsGeneric: [...state.productsGeneric, action.payload.data],
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_PRODUCTS_GENERIC_FAIL:
      return {
        ...state, isLoaded: false, isLoading: false, error: action.error,
      };
    default: return state;
  }
};

export const ProductsRelatedReducer = (state = initialState, action = {}) => {
  switch (action.type) {

    case FETCH_PRODUCTS_RELATED:
      return { ...state, isLoadingRelated: true };
    case FETCH_PRODUCTS_RELATED_SUCCESS:
      return {
        ...state,
        productsRelated: action.payload.data,
        isLoadingRelated: false,
        isSuccessRelated: true,
        isErrorRelated: false,
      };
    case FETCH_PRODUCTS_RELATED_FAIL:
      return {
        ...state,
        isLoadingRelated: false,
        isErrorRelated: true,
        isSuccessRelated: false,
      };

    case RESET_RELATED_PRODUCTS:
      state = {
        ...state,
        productsGeneric: [],
        productsRelated: [],
        isLoadingRelated: false,
        isErrorRelated: false,
        isSuccessRelated: false
      };
      return state;

    default: return state;
  }
};